import Help from 'components/activity/help/main/container/HelpContainer';
import ZendeskFAQsItem from 'components/activity/help/zendeskFAQsItem/containers/ZendeskFAQsItemContainer';

export default [
    { path: ':id', component: ZendeskFAQsItem, pageTitle: 'Help' },
    { path: '', component: Help, pageTitle: 'Help' },
];
